<template>
  <v-app>
    <v-toolbar>
      <v-btn icon class="hidden-xs-only">
        <v-icon>shield</v-icon>
      </v-btn>
      <v-toolbar-title>Replicate.one</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="user !== null">
        <v-btn flat><v-icon left>battery_full</v-icon> {{energy}}</v-btn>
        <v-btn flat><v-icon left>favorite</v-icon> 100%</v-btn>
        <v-btn flat>1,000 EXP TO GO</v-btn>
        <v-btn flat @click="logout">Logout {{user.name}} <v-icon right>logout</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <label v-if="!connected">Disconnected from the world...</label>
        <Login v-else-if="user === null" />
        <template v-else>
          <v-flex xs12 md4 id="map">
            <table cellspacing=0 cellpadding=0>
              <tr ref="row1">
                <td ref="row1-cell1"></td>
                <td ref="row1-cell2"></td>
                <td ref="row1-cell3"></td>
                <td ref="row1-cell4"></td>
                <td ref="row1-cell5"></td>
                <td ref="row1-cell6"></td>
                <td ref="row1-cell7"></td>
                <td ref="row1-cell8"></td>
                <td ref="row1-cell9"></td>
              </tr>
              <tr ref="row2">
                <td ref="row2-cell1"></td>
                <td ref="row2-cell2"></td>
                <td ref="row2-cell3"></td>
                <td ref="row2-cell4"></td>
                <td ref="row2-cell5" class="dig" @click="doDig('north')" title="dig"></td>
                <td ref="row2-cell6"></td>
                <td ref="row2-cell7"></td>
                <td ref="row2-cell8"></td>
                <td ref="row2-cell9"></td>
              </tr>
              <tr ref="row3">
                <td ref="row3-cell1"></td>
                <td ref="row3-cell2"></td>
                <td ref="row3-cell3"></td>
                <td ref="row3-cell4"></td>
                <td ref="row3-cell5" class="scan" @click="doScan('north')" title="scan"></td>
                <td ref="row3-cell6"></td>
                <td ref="row3-cell7"></td>
                <td ref="row3-cell8"></td>
                <td ref="row3-cell9"></td>
              </tr>
              <tr ref="row4">
                <td ref="row4-cell1"></td>
                <td ref="row4-cell2"></td>
                <td ref="row4-cell3"></td>
                <td ref="row4-cell4"></td>
                <td ref="row4-cell5" class="move" @click="doMove('north')" title="move"></td>
                <td ref="row4-cell6"></td>
                <td ref="row4-cell7"></td>
                <td ref="row4-cell8"></td>
                <td ref="row4-cell9"></td>
              </tr>
              <tr ref="row5">
                <td ref="row5-cell1"></td>
                <td ref="row5-cell2" class="dig" @click="doDig('west')" title="dig"></td>
                <td ref="row5-cell3" class="scan" @click="doScan('west')" title="scan"></td>
                <td ref="row5-cell4" class="move" @click="doMove('west')" title="move"></td>
                <td ref="row5-cell5" class="current">X</td>
                <td ref="row5-cell6" class="move" @click="doMove('east')" title="move"></td>
                <td ref="row5-cell7" class="scan" @click="doScan('east')" title="scan"></td>
                <td ref="row5-cell8" class="dig" @click="doDig('east')" title="dig"></td>
                <td ref="row5-cell9"></td>
              </tr>
              <tr ref="row6">
                <td ref="row6-cell1"></td>
                <td ref="row6-cell2"></td>
                <td ref="row6-cell3"></td>
                <td ref="row6-cell4"></td>
                <td ref="row6-cell5" class="move" @click="doMove('south')" title="move"></td>
                <td ref="row6-cell6"></td>
                <td ref="row6-cell7"></td>
                <td ref="row6-cell8"></td>
                <td ref="row6-cell9"></td>
              </tr>
              <tr ref="row7">
                <td ref="row7-cell1"></td>
                <td ref="row7-cell2"></td>
                <td ref="row7-cell3"></td>
                <td ref="row7-cell4"></td>
                <td ref="row7-cell5" class="scan" @click="doScan('south')" title="scan"></td>
                <td ref="row7-cell6"></td>
                <td ref="row7-cell7"></td>
                <td ref="row7-cell8"></td>
                <td ref="row7-cell9"></td>
              </tr>
              <tr ref="row8">
                <td ref="row8-cell1"></td>
                <td ref="row8-cell2"></td>
                <td ref="row8-cell3"></td>
                <td ref="row8-cell4"></td>
                <td ref="row8-cell5" class="dig" @click="doDig('south')" title="dig"></td>
                <td ref="row8-cell6"></td>
                <td ref="row8-cell7"></td>
                <td ref="row8-cell8"></td>
                <td ref="row8-cell9"></td>
              </tr>
              <tr ref="row9">
                <td ref="row9-cell1"></td>
                <td ref="row9-cell2"></td>
                <td ref="row9-cell3"></td>
                <td ref="row9-cell4"></td>
                <td ref="row9-cell5"></td>
                <td ref="row9-cell6"></td>
                <td ref="row9-cell7"></td>
                <td ref="row9-cell8"></td>
                <td ref="row9-cell9"></td>
              </tr>
            </table>
          </v-flex>
          <v-flex xs12 md8 id="room">
            <v-card>
              <v-card-title>
                <span class="title">Room {{getX}} {{getY}}</span>
              </v-card-title>
              <v-container v-if="getPeople.length > 0">
                <h2>In room:</h2>
                <v-chip v-for="(m, index) in getPeople" v-bind:key="index">{{m}}</v-chip></v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 id="messages">
            <v-card>
              <v-list>
                <template v-for="(m, index) in messages.slice(Math.max(messages.length - 5, 0))">
                  <v-list-tile v-bind:key="'t'+index">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{m}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-bind:key="'d'+index"></v-divider>
                </template>
                <v-list-tile>
                  <v-list-tile-action @click="shout=!shout">
                    <span v-if="shout">[ Chat ]</span><span v-else>[ Say ]</span>
                  </v-list-tile-action>
                  <v-text-field v-model="shoutMessage" @keyup.enter="doChat" placeholder="[ write your message here ]" />
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex xs12 id="queue">
            <v-toolbar>
              <v-toolbar-title>Queue</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down" v-if="queue.length >  0">
                <v-btn flat v-for="(m, index) in queue.slice(0, Math.min(5))" v-bind:key="index">
                  <v-icon left>{{toIcon(m)}}</v-icon>
                  {{ m.name == 'move' || m.name == 'scan' || m.name == 'dig' ? m.direction[0] : ''}}
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import Login from './components/Login.vue'

export default {
  name: 'app',
  data () {
    return {
      shout: true,
      shoutMessage: ''
    }
  },
  components: {
    Login
  },
  computed: {
    connected () {
      return this.$store.state.connect
    },
    messages () {
      return this.$store.state.messages
    },
    queue () {
      return this.$store.state.queue
    },
    user () {
      return this.$store.state.user
    },
    energy () {
      return this.$store.state.energy
    },
    getX () {
      return this.$store.state.x
    },
    getY () {
      return this.$store.state.y
    },
    getPeople () {
      return this.$store.state.people
    },
    getRooms () {
      return this.$store.state.rooms
    }
  },
  watch: {
    getRooms () {
      // loop through set map
      console.log('building map') // eslint-disable-line no-console
      for (let x = 1; x <= 9; x++) {
        for (let y = 1; y <= 9; y++) {
          this.$refs[`row${y}-cell${x}`].style.backgroundColor = 'gray'
          this.$refs[`row${y}-cell${x}`].classList.remove('new')
        }
      }

      this.getRooms.forEach(room => {
        let color = 'green'
        if (room.type === 2) {
          color = 'darkgreen'
        } else if (room.type === 3) {
          color = 'lightgreen'
        } else if (room.type === 4) {
          color = 'yellow'
        } else if (room.type === 5) {
          color = 'brown'
        } else if (room.type === 6) {
          color = 'orange'
        } else if (room.type === 7) {
          color = 'lightyellow'
        } else if (room.type === 8) {
          color = 'lightsalmon'
        } else if (room.type === 9) {
          color = 'lightseagreen'
        } else if (room.type === 10) {
          color = 'lightskyblue'
        } else if (room.type === 11) {
          color = 'darkkhaki'
        } else if (room.type === 12) {
          color = 'cornflowerblue'
        } else if (room.type === 13) {
          color = 'darkblue'
        } else if (room.type === 14) {
          color = 'darkgray'
        }
        this.$refs[`row${(room.y - this.getY) + 5}-cell${(room.x - this.getX) + 5}`].style.backgroundColor = color
        if (room.explorer == null) {
          this.$refs[`row${(room.y - this.getY) + 5}-cell${(room.x - this.getX) + 5}`].classList.add('new')
        }
      })
    }
  },
  methods: {
    toIcon (item) {
      if (item.name === 'move') {
        return 'room'
      } else if (item.name === 'scan') {
        return 'settings_remote'
      } else if (item.name === 'dig') {
        return 'warning'
      }
      return 'help'
    },
    logout () {
      location.reload()
    },
    doChat () {
      console.log('messaging') // eslint-disable-line no-console
      this.$socket.emit(this.shout ? 'chat' : 'say', this.shoutMessage)
      this.shoutMessage = ''
    },
    doMove (direction) {
      console.log('moving') // eslint-disable-line no-console
      this.$socket.emit('action', {
        name: 'move',
        direction
      })
    },
    doScan (direction) {
      console.log('scanning') // eslint-disable-line no-console
      this.$socket.emit('action', {
        name: 'scan',
        direction
      })
    },
    doDig (direction) {
      console.log('digging') // eslint-disable-line no-console
      this.$socket.emit('action', {
        name: 'dig',
        direction
      })
    }
  }
}
</script>

<style lang="scss">
  #map td {
    box-sizing: border-box;
    border: 1px solid #269;
    height: 40px;
    width: 40px;
    background-color: black;
  }
  #map .move {
    cursor: pointer;
    border-color: yellow;
  }
  #map .scan {
    cursor: pointer;
    border-color: orange;
  }
  #map .dig {
    cursor: pointer;
    border-color: red;
  }
  #map .current {
    border-color: darkgreen;
  }

  #map .new {
    background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5) 3px,
      rgba(0, 0, 0, 0) 3px,
      rgba(0, 0, 0, 0) 6px
    )
  }
</style>
